import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { GbDashboardDialogService } from '@galabid/gb-dashboard/shared/utils'
import { PresenterContextService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-context/presenter-context.service'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'
import {
  GbPresenterItemFilterDialogComponent,
  GbPresenterItemFilterDialogResult,
} from '../gb-presenter-item-filter-dialog/gb-presenter-item-filter-dialog.component'
import { GbPresenterExcludedItemsDialogComponent } from '../gb-presenter-excluded-items-dialog/gb-presenter-excluded-items-dialog.component'

@Component({
  selector: 'gb-presenter-tools-total-raised',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbPresenterToolsTextComponent,
  ],
  templateUrl: './gb-presenter-tools-total-raised.component.html',
  styleUrl: './gb-presenter-tools-total-raised.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsTotalRaisedComponent {
  @Input() toolsFormGroup!: FormGroup

  hideFields = ['font_style']

  constructor(
    private gbDashboardDialogService: GbDashboardDialogService,
    private presenterContextService: PresenterContextService,
  ) {}

  get isTemplateMode(): boolean {
    return this.presenterContextService.isTemplateMode
  }

  borderStyleOptions = [
    { value: 'solid', label: 'PRESENTER.TOTAL_RAISED_TOOLS.BORDER_STYLES.SOLID' },
    { value: 'dashed', label: 'PRESENTER.TOTAL_RAISED_TOOLS.BORDER_STYLES.DASHED' },
    { value: 'dotted', label: 'PRESENTER.TOTAL_RAISED_TOOLS.BORDER_STYLES.DOTTED' },
    { value: 'double', label: 'PRESENTER.TOTAL_RAISED_TOOLS.BORDER_STYLES.DOUBLE' },
  ]

  get labelControl(): FormControl {
    return this.toolsFormGroup.get('label') as FormControl
  }

  get trackBidsControl(): FormControl {
    return this.toolsFormGroup.get('track_bids') as FormControl
  }

  get trackDonationsControl(): FormControl {
    return this.toolsFormGroup.get('track_donations') as FormControl
  }

  get trackPurchasesControl(): FormControl {
    return this.toolsFormGroup.get('track_purchases') as FormControl
  }

  get trackRafflesControl(): FormControl {
    return this.toolsFormGroup.get('track_raffles') as FormControl
  }

  get trackTicketSalesControl(): FormControl {
    return this.toolsFormGroup.get('track_ticket_sales') as FormControl
  }

  get baseTotalRaisedEnabledControl(): FormControl {
    return this.toolsFormGroup.get('base_total_raised_enabled') as FormControl
  }

  get backgroundColorControl(): FormControl {
    return this.toolsFormGroup.get('background_color') as FormControl
  }

  get borderWidthControl(): FormControl {
    return this.toolsFormGroup.get('border_width') as FormControl
  }

  get borderColorControl(): FormControl {
    return this.toolsFormGroup.get('border_color') as FormControl
  }

  get borderStyleControl(): FormControl {
    return this.toolsFormGroup.get('border_style') as FormControl
  }

  get hiddenItemsControl(): FormControl {
    return this.toolsFormGroup.get('hidden_items') as FormControl
  }

  openFilterItemsDialog(): void {
    const hiddenItemUuids = (this.hiddenItemsControl?.value || []) as string[]

    const dialogRef = this.gbDashboardDialogService.openDialog(GbPresenterItemFilterDialogComponent, {
      width: '750px',
      maxWidth: '95vw',
      data: { hiddenItemUuids },
    })

    dialogRef.afterClosed().subscribe((result: GbPresenterItemFilterDialogResult | undefined) => {
      if (!result) return

      this.hiddenItemsControl.setValue(result.hiddenItemUuids)
      this.hiddenItemsControl.markAsDirty()
      this.toolsFormGroup.markAsDirty()
    })
  }

  get excludedItemsCount(): number {
    return ((this.hiddenItemsControl?.value || []) as string[]).length
  }

  openExcludedItemsDialog(): void {
    const hiddenItemUuids = (this.hiddenItemsControl?.value || []) as string[]

    this.gbDashboardDialogService.openDialog(GbPresenterExcludedItemsDialogComponent, {
      width: '700px',
      maxWidth: '95vw',
      data: { hiddenItemUuids },
    })
  }
}
